import { LegalShell, LegalSection } from "@/components/LegalShell";

export default function Privacy() {
  return (
    <LegalShell eyebrow="Your information" title="Privacy Policy" updated="October 2026" testId="privacy-page">
      <LegalSection title="1. Our commitment">
        <p>
          EduPower Foundation (NPC 2024/513680/0) respects your privacy and handles personal
          information in line with the Protection of Personal Information Act 4 of 2013 (POPIA).
          Because our programmes involve minors, we take extra care with any information relating
          to children.
        </p>
      </LegalSection>

      <LegalSection title="2. What we collect">
        <p>
          Gallery comments: the name you choose to enter and your comment. Likes and shares are
          anonymous counts.
        </p>
        <p>
          Donations: the donation amount and status. Payment details are handled entirely by
          PayFast and never reach our servers.
        </p>
        <p>
          Team accounts: the admin email address and a securely hashed password, used only for
          managing the website.
        </p>
        <p>
          Programme participation: learner information is collected and held through partner
          schools with parent or guardian consent, not through this website.
        </p>
      </LegalSection>

      <LegalSection title="3. Photographs and videos of learners">
        <p>
          Images and videos of learners appear on this website only with consent obtained through
          the partner school and/or parent or guardian. We do not publish learner surnames or
          identifying details alongside images unless specific consent has been given. Parents,
          guardians and schools may request removal of any image at any time by emailing
          admin@edupowerfoundation.org, and we will remove it promptly.
        </p>
      </LegalSection>

      <LegalSection title="4. How we use information">
        <p>
          We use the information above to run the website, display community interactions, process
          and acknowledge donations, and manage the site. We do not sell or rent personal
          information to anyone.
        </p>
      </LegalSection>

      <LegalSection title="5. Who processes information">
        <p>
          Donations are processed by PayFast. Transactional email (such as password resets and
          donor thank-you messages) is sent through our email service provider. These providers
          process information only to deliver their service to us.
        </p>
      </LegalSection>

      <LegalSection title="6. How long we keep it">
        <p>
          Gallery comments stay with their gallery moment unless removed by you or by us. Donation
          records are kept as required for our financial records as a non-profit company. Admin
          account information is kept while the account is active.
        </p>
      </LegalSection>

      <LegalSection title="7. Your rights">
        <p>
          Under POPIA you may ask us what personal information we hold about you, ask us to correct
          or delete it, and object to its processing. Contact our Information Officer at
          admin@edupowerfoundation.org.
        </p>
        <p>
          You also have the right to complain to the Information Regulator (South Africa) at
          enquiries@inforegulator.org.za.
        </p>
      </LegalSection>

      <LegalSection title="8. Security">
        <p>
          Passwords are stored only as secure hashes, payment pages run over encrypted connections,
          and access to administration features is restricted to authorised team members.
        </p>
      </LegalSection>

      <LegalSection title="9. Changes">
        <p>
          We may update this policy from time to time and will note the date of the latest version
          above. Questions can be sent to admin@edupowerfoundation.org.
        </p>
      </LegalSection>
    </LegalShell>
  );
}
